
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";
import useAuth from "@/auth/composables/useAuth";

export default defineComponent({
  name: "menuPerfil",
  components: {},
  setup() {
    const router = useRouter();

    const {
      username,
      email,
      image,
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      logout,
    } = useAuth();
    let imagen = ref("");
    if (image.value.length < 100) {
      imagen.value =
        "https://eitrawmaterials.eu/wp-content/uploads/2016/09/person-icon.png";
    } else {
      imagen.value = image.value;
    }
    return {
      username,
      email,
      imagen,
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      onLogout: () => {
        router.push({ name: "sign-in" });
        localStorage.clear();
        logout();
      },
    };
  },
});
